import React, { useEffect, useRef, useState } from 'react';
import { NavBarTypes } from '../../sections/sitewide/components/NavBar/navBarTypes';
import { Navbar } from '@codeparva/ui-components-library';
import { weakKey } from '../../utilities/weakKey';
import { desktopscreensize } from '../../utilities/constants';
import { Link } from 'gatsby';
import { useLocation } from '@reach/router';
import { useVariant } from '../../sections/sitewide/components/NavBar/hooks/NavBarContext';
import { useThemeContext } from '../../sections/sitewide/components/Footer/hooks/themeContext';
import { TickMarkHelper } from './helper/TickMark';
import { ClassNameHelperNavBarLinks } from './helper/utilities/NavBarLinkClass';
import { LinkTouchDeviceHandler } from './helper/NavBarLinkTouchHandler';
import { getLinkInfo } from '../../utilities/links/LinkHelper';
import {
  handleDropDownState,
  handleReRoutingAndDropDownState,
} from './helper/utilities/NavBarClickHandler';
import { getClassesForNavBarLinks } from './helper/utilities/NavLinkColorPicker';
import { Icon } from '../../utilities/icomoon-css';

export const HeaderLinkContent = ({
  locationDetails,
  NavLinkText,
  linkTo,
  navLinkDropDown,
  isGrouped,
  isNavLinkDropDown,
  openNavBar,
  LinkWrapper,
  newTab,
  globalContext,
  selectedLocationName,
}: NavBarTypes.THeaderLinkContent) => {
  const currentDetails = useVariant();
  const currTheme = useThemeContext();
  const linkRef = useRef<any>(null);
  const [NavBarLinkColor, setNavBarLinkColor] = useState('dark');
  useEffect(() => {
    const { NavBarLinkColor } = getClassesForNavBarLinks(currTheme);
    setNavBarLinkColor(NavBarLinkColor);
  }, []);
  const NavLinkHelperTouchDevices = () => {
    return currentDetails.widthwindow < desktopscreensize ? (
      <LinkTouchDeviceHandler
        locationDetails={locationDetails}
        linkTo={linkTo}
        NavLinkText={NavLinkText}
        navLinkDropDown={navLinkDropDown}
      />
    ) : (
      <>{NavLinkText}</>
    );
  };

  if (isNavLinkDropDown && navLinkDropDown.length > 0 && !isGrouped) {
    const getTextColor = () => {
      return currTheme === 'light' &&
        NavLinkText === 'Locations' &&
        location.pathname.includes('view-rates')
        ? 'primary'
        : 'dark';
    };
    return (
      <Navbar.Item
        hoverable
        href="#"
        renderAs="div"
        key={weakKey({ linkTo })}
        className={`navBarLinks has-text-${getTextColor()}`}
      >
        <NavLinkHelperTouchDevices />
        <Navbar.Dropdown
          boxed
          clickable={false}
          key={weakKey({ locationDetails })}
          className={
            !currentDetails.dropDownState ||
            currentDetails.activeComponent === NavLinkText
              ? `navBarDropDownActive mt-4 cp-link-${NavBarLinkColor}`
              : `navBarDropDown mt-4 cp-link-${NavBarLinkColor}`
          }
        >
          {navLinkDropDown.map(
            (navLink: {
              subLinkUrl: string;
              subLinkName: string;
              location_state: string;
              location_city: string;
            }) => {
              let {
                subLinkName,
                subLinkUrl,
                location_city,
                location_state,
              } = navLink;
              subLinkUrl = `/${location_state}/${location_city}/${subLinkUrl}`;
              return (
                <Navbar.Item
                  href={subLinkUrl}
                  hoverable={true}
                  key={weakKey({ navLink })}
                  renderAs="div"
                  active={openNavBar}
                >
                  <LinkWrapper
                    to={subLinkUrl}
                    state={{
                      from: NavLinkText.toLowerCase().replace(/\s/g, ''),
                      dataFrom: 'navBar',
                    }}
                    getProps={({ isCurrent }: { isCurrent: boolean }) => {
                      return ClassNameHelperNavBarLinks(
                        isCurrent,
                        currentDetails,
                        currTheme,
                        NavLinkText
                      );
                    }}
                    onClick={(e: any) => handleDropDownState(e, currentDetails)}
                    key={weakKey(navLink)}
                    className={`navLinks has-text-weight-bold cp-link-${NavBarLinkColor}`}
                  >
                    <Navbar.Divider />
                    <span className="subLinkNameEnclosure">
                      {location.pathname.includes('view-rates') &&
                      selectedLocationName === subLinkName ? (
                        <Icon
                          name="tfw-tenant-cp"
                          size={24}
                          title="tfw-tenant-cp"
                        />
                      ) : (
                        <></>
                      )}
                      <span>{subLinkName}</span>
                    </span>
                  </LinkWrapper>
                </Navbar.Item>
              );
            }
          )}
        </Navbar.Dropdown>
      </Navbar.Item>
    );
  } else if (navLinkDropDown.length > 0 && isNavLinkDropDown && isGrouped) {
    return (
      <Navbar.Item
        hoverable={true}
        href="#"
        renderAs="div"
        key={weakKey({ linkTo })}
        className="navBarLinks"
      >
        <Link
          to={linkTo}
          state={{
            from: NavLinkText.toLowerCase().replace(/\s/g, ''),
          }}
        >
          <Navbar.Link
            arrowless={false}
            renderAs="div"
            key={weakKey(navLinkDropDown)}
            className={`navBarLinkGrouped cp-link-${NavBarLinkColor}`}
            onClick={(e: any) => handleDropDownState(e, currentDetails)}
          >
            {NavLinkText}
            <TickMarkHelper
              currentDetails={currentDetails}
              NavLinkText={NavLinkText}
            />
          </Navbar.Link>
        </Link>
        <Navbar.Dropdown
          right={true}
          boxed={true}
          key={weakKey({ locationDetails })}
          className={
            currentDetails.dropDownState
              ? 'navBarLinkGroup'
              : 'navBarLinkGroupActive'
          }
        >
          {navLinkDropDown.map((navLink: NavBarTypes.TNavLinkDropDown) => {
            return (
              <Navbar.Item
                href={navLink.subLinkUrl}
                key={weakKey(navLink)}
                renderAs="div"
                active={!openNavBar}
              >
                <LinkWrapper
                  to={navLink.subLinkUrl}
                  state={{
                    from: NavLinkText.toLowerCase().replace(/\s/g, ''),
                  }}
                  getProps={({ isCurrent }: { isCurrent: boolean }) => {
                    return ClassNameHelperNavBarLinks(
                      isCurrent,
                      currentDetails,
                      currTheme,
                      NavLinkText
                    );
                  }}
                  onClick={(e: any) =>
                    handleReRoutingAndDropDownState(e, currentDetails)
                  }
                  key={weakKey(navLink)}
                  className={`navLinks has-text-weight-bold cp-link-${NavBarLinkColor}`}
                >
                  <Navbar.Divider />
                  {navLink.subLinkName}
                </LinkWrapper>
              </Navbar.Item>
            );
          })}
        </Navbar.Dropdown>
      </Navbar.Item>
    );
  } else {
    return (
      <LinkWrapper
        ref={linkRef}
        to={getLinkInfo(locationDetails, NavLinkText, linkTo, globalContext)}
        onClick={(e: any) => {
          const linkTag = linkRef.current;
          linkTag.className =
            'active navLinkCommon has-text-primary cp-link-dark';
          currentDetails.handleNavFunctions.handleNavBarRef(linkTag.innerText);
          handleReRoutingAndDropDownState(e, currentDetails);
        }}
        state={{ from: NavLinkText.toLowerCase().replace(/\s/g, '') }}
        getProps={({ isCurrent }: { isCurrent: boolean }) => {
          return ClassNameHelperNavBarLinks(
            isCurrent,
            currentDetails,
            currTheme,
            NavLinkText
          );
        }}
        target={newTab ? '_blank' : ''}
      >
        {NavLinkText}
      </LinkWrapper>
    );
  }
};

export const CPHeaderLinkWrapper = ({
  children,
  NavLinkText,
  index,
}: NavBarTypes.TCPHeaderLinkWrapper) => {
  const currentDetails = useVariant();
  currentDetails.navLinkRef = useRef<HTMLDivElement>(null);
  const location = useLocation();

  const activeNavBarItemHelper = () => {
    if (
      (currentDetails.activeComponent === NavLinkText &&
        currentDetails.activeComponent !== 'Home') ||
      (NavLinkText === 'Home' && location.pathname === '/') ||
      ((NavLinkText === 'Locations' || NavLinkText === 'View Rates') &&
        location.pathname.includes('view-rates')) ||
      (NavLinkText === 'Pay Rent' &&
        location.pathname.includes('/account/login'))
    ) {
      return 'activeNavBarItem';
    } else {
      return 'NavBarItem';
    }
  };
  const getClassNameForCPHeaderLink = () => {
    return `${NavLinkText &&
      NavLinkText.split(' ').join('')} ${activeNavBarItemHelper()}`;
  };
  return NavLinkText !== undefined ? (
    <div
      id="navItem"
      data-cy={`navBarLink-${index}`}
      className={`navbar-item is-hoverable ${getClassNameForCPHeaderLink()}`}
      data-testid={`link-${getClassNameForCPHeaderLink()}`}
    >
      {children}
    </div>
  ) : (
    <></>
  );
};
